const urlName = '/usercenter/v1'
export default API => ({
    findUserOrganList() {
        return API({ // 详情列表
            url: `${urlName}/user/findUserOrganList`,
        });
    },
    findUser () {
        return API({ url: `${urlName}/user/findUser` });
    },
    updateUser(params){
        return API({ url: `${urlName}/user/updateUser`, method: 'post', params });
    },
    upload (data){
        return API({
            url: '/resource/v1/resource/uploadImage',
            method: 'post',
            data
        })
    },
    // 交通获取用户信息
    findByUserId(){
        return API({
        url: `/saas/v1/userCustomExtend/findByUserId`,
        method: 'get',
        });
    },
    jiaotongSave(data){
        return API({
        url: `/saas/v1/userCustomExtend/studentSave`,
        method:'post',
        data
        });
    }
})